import './index.scss';
import React, { useState, useContext, useRef } from 'react';
import { Icon } from 'antd-mobile';
import { MyContext } from '@/utils/contextManager';
import _ from 'lodash';

const Placeholder = '请输入关键词搜索...';

const SelectIcon = (props) => (
  <svg
    className={props.className}
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="10522"
  >
    <path
      d="M568.553 954.182a86.342 86.342 0 0 1-41.426-10.473l-114.269-62.836a86.575 86.575 0 0 1-44.916-76.102V442.18a16.99 16.99 0 0 0-6.982-13.73L97.047 218.298l-3.956-3.49a85.876 85.876 0 0 1 62.836-144.99h711.215a86.575 86.575 0 0 1 63.767 144.99l-3.49 3.49-266.24 213.411a17.455 17.455 0 0 0-6.052 13.731v422.4a86.342 86.342 0 0 1-86.574 86.342z m-426.59-787.55l262.284 209.455a85.178 85.178 0 0 1 32.815 66.095V804.77a17.92 17.92 0 0 0 8.61 15.593l114.27 62.138a17.687 17.687 0 0 0 17.687 0 17.222 17.222 0 0 0 8.378-15.36V445.44a85.876 85.876 0 0 1 31.884-67.258l263.214-211.55a17.687 17.687 0 0 0 1.63-18.152 17.455 17.455 0 0 0-15.593-8.844H155.927a17.222 17.222 0 0 0-13.963 27.695zM920.67 512H731.695a34.444 34.444 0 0 1 0-69.818h188.974a34.444 34.444 0 0 1 0 69.818z m0 128.93H731.695a34.444 34.444 0 0 1 0-69.817h188.974a34.444 34.444 0 0 1 0 69.818z m0 128H731.695a34.444 34.444 0 0 1 0-69.817h188.974a34.444 34.444 0 0 1 0 69.818z"
      p-id="10523"
    ></path>
  </svg>
);

const CloseIcon = (props) => (
  <svg
    className={props.className}
    viewBox="64 64 896 896"
    focusable="false"
    data-icon="close-circle"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 0 1-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path>
  </svg>
);

const SearchWrapper = (props) => {
  const { onChange = () => {}, hideSelector = false, className } = props;

  const [msg, setMsg] = useState('');

  const { setDrawer = () => {} } = useContext(MyContext);

  const watchInput = (value) => {
    setMsg(value);
  };

  const switchDrawer = () => {
    setDrawer();
  };

  const changeInput = useRef(
    _.debounce((value) => {
      onChange(value);
    }, 500),
  ).current;

  const handelChange = (e) => {
    e.persist();
    setMsg(e.target.value);
    changeInput(e.target.value);
  };
  // console.log(hideSelector);
  return (
    <div className={`search-wrapper ${className}`}>
      <div className="search-input-wrapper">
        <div className="search-input">
          {className ? (
            <em className="iconSearch" />
          ) : (
            <Icon type="search" className="search-input-icon" />
          )}
          <input
            type="text"
            placeholder={Placeholder}
            onChange={handelChange}
            onBlur={() => {
              onChange(msg);
            }}
            value={msg}
          ></input>
          {msg !== '' && (
            <span
              onClick={() => {
                watchInput('');
                onChange('');
              }}
            >
              <CloseIcon className={'search-input-close'}></CloseIcon>
            </span>
          )}
        </div>
        {!hideSelector && (
          <div
            className="search-selectButton"
            onClick={() => {
              switchDrawer();
            }}
          >
            {className ? (
              <em className="iconSelect" />
            ) : (
              <SelectIcon className="search-select-icon" />
            )}
            <div>筛选</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchWrapper;
